import { jsx as _jsx } from "react/jsx-runtime";
export function Icon({ name, size = 16, className, }) {
    return (_jsx("svg", { width: size, height: size, className: className, "aria-hidden": "true", children: _jsx("use", { href: `#i-${name}` }) }));
}
